import React from 'react';
import { MSG, MSGdetail, AvatarDot, IconView, BlankDiv, Read, MSGtitle, MSGtext, BottomButton } from '../styles';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import Button from '../../../component/button';
import { BUTTON_TYPE } from '../../../global/constants';
import { isEmpty } from '../../../helpers/common';
import { InboxCardProps } from '../../../interfaces/NotificationInterface';

const InboxCard: React.FC<InboxCardProps> = ({
  iconName,
  title,
  text,
  buttonTitle,
  buttonAction,
  dismissAction,
  className,
  backgroundUrl,
  secondaryButtonTitle,
  secondaryButtonAction
}) => {
  return (
    <MSG backgroundUrl={backgroundUrl}>
      <MSGdetail className={className}>
        <AvatarDot>
          <IconView className='pointer'>
            <BlankDiv />
          </IconView>
          <SVGIcon name={iconName} width='28px' height='28px' viewBox='0 0 28 28' className='svg-icon' />
        </AvatarDot>
        <Read>
          <MSGtitle className={className}>{title}</MSGtitle>
          <MSGtext className={className}>{text}</MSGtext>
          <BottomButton>
            <Button title={buttonTitle} variant={BUTTON_TYPE.SECONDARY} onClick={buttonAction} size='small' />
            {!isEmpty(secondaryButtonTitle) && (
              <Button
                title={secondaryButtonTitle}
                variant={BUTTON_TYPE.SECONDARY}
                onClick={secondaryButtonAction}
                size='small'
              />
            )}
            <Button variant={BUTTON_TYPE.TERTIARY} title='Dismiss' onClick={dismissAction} size='small' />
          </BottomButton>
        </Read>
      </MSGdetail>
    </MSG>
  );
};

export default InboxCard;
